import { render } from "./Exhibitions.vue?vue&type=template&id=0f6ed65d&scoped=true"
import script from "./Exhibitions.vue?vue&type=script&lang=js"
export * from "./Exhibitions.vue?vue&type=script&lang=js"

import "./Exhibitions.vue?vue&type=style&index=0&id=0f6ed65d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6ed65d"]])

export default __exports__